/*
 *  Home Hero Carousel
 *    Scripts for the Homepage Hero Carousel section. Creates a slick slide for
 *    smaller devices.
 *
 *  Version:
 *    1.0.0 - 2020/03/19
 */

import { CarouselSection } from './CarouselSection';
import { register } from '../sections/ShopifySection';
import * as ResponsiveSizes from '../../settings/Responsive';

//Selectors
const CONTAINER_SELECTOR = '[data-home-hero-carousel-container]';
const CAROUSEL_SELECTOR = '[data-home-hero-carousel]';


/**
 * @Class
 * Home Hero Carousel
 */
export class HomeHeroCarousel extends CarouselSection {

  constructor(container) {
    super(container);
    this.carouselContainer = this.container.find(CAROUSEL_SELECTOR);
    if (!this.carouselContainer) return;

    this.autoplaySpeed = 3000;
    this.autoplay = true;
    if (this.carouselContainer.attr('data-settings').length) {
      try {
        const settings = JSON.parse(this.carouselContainer.attr('data-settings'));
        this.autoplaySpeed = settings.autoplaySpeed;
        this.autoplay = settings.autoplay;
      } catch(e) {
        console.error(e); 
      }
    }

    this.slickInit = false;

    this.slick = this.initCarousel(this.carouselContainer);
    this.slickInit = true;
  }

   /**
   * Overrides defaults with custom Slick configuration
   * @method
   * @return {object}
   */
   optionOverrides() {
    return {
      autoplay: this.autoplay,
      autoplaySpeed: this.autoplaySpeed,
      swipeToSlide: true,
      mobileFirst: true,
      dots: false,
      arrows: true,
      slidesToShow: 1,
      adaptiveHeight: true,
      slidesToScroll: 1,
      responsive: []
    };
  }

}

register(CONTAINER_SELECTOR, HomeHeroCarousel);
